export default __webpack_public_path__ + "static/media/社区聚集地_white.7d7e7be3.jpg";